import classNames from 'classnames';
import styled from 'styled-components';
import {
  maxMobile,
  maxTablet,
  maxWidth1300, midTablet,
  primaryHeadingColor, secondaryFont, wMBold,
} from 'Utils/utilsStyle';
import { useDispatch, useSelector } from 'react-redux';
import { actions as personProfileActions } from 'Slice/PersonProfileSlice';
import {
  selectCreateDigestData, selectPersonDigestLoading, selectRedirectWorkbench, selectShowDigestPopup,
} from 'Selector/PersonProfileSelector';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

type DigestProps = {
  widgetId?: string,
  title?: string,
  personWidget?: boolean,
  imagesURL?: string[],
  themeId?: string,
  createDigest?: (a: string) => void
} & typeof defaultProps;

const defaultProps = {
  widgetId: '',
  title: '',
  personWidget: false,
  imagesURL: [] as string[],
  themeId: '',
  createDigest: (a: string) => { },
};

const Wrapper = styled.div`
&.personDigestTile {
  width: 223px;
  height: 214px;
  margin: 0px auto;
  @media all and (min-width: 1700px) {
    width: auto;
    margin: 0px 20px;
  }

  @media all and (max-width: ${maxWidth1300}) {
    width: auto;
    margin: 0px 10px;
  }
  @media all and (max-width: ${maxTablet}) {
    width: 122px;
    height: 117px;
    border-radius: 4px;
    margin-right: 0px;
  }
  @media all and (max-width: ${midTablet}) {
    width: auto;
    margin: 0px 10px;
  }
  @media all and (max-width: ${maxMobile}) {
    /* margin-right: 0px; */
  }
  .image-wrapper-styled {
    height: 120px;  
    @media all and (max-width: ${maxTablet}) {
      height: 66px;  
    }
  }
  .digest-text-wrapper {
    @media all and (max-width: ${maxTablet}) {
      padding: 4px 9px 0px 6px;
    }
    .digest-tile-paragraph {
      @media all and (max-width: ${maxTablet}) {
        font-size: 12px;
        line-height: 14px;
      }
    }
  }
}
  height: 218px;
  width: 250px;
  margin-right:15px;
  border-radius: 10px;
  overflow:hidden;
  @media all and (min-width: 1700px) {
    width: auto;
  }
  @media all and (max-width: ${maxTablet}) {
    width: auto;
  }
  .digestTileImage {
   width: 30%;
  }
  .heroImageWrap {
    height: 100%;
    width: 70%;
  }
`;

const ImageWrapper = styled.div`
  height: 135px;
`;

const TextWrapper = styled.div`
  background-color: white;
  padding: 14px 20px 20px 19px;
`;

const Paragraph = styled.p`
  font-family: ${secondaryFont};
  font-weight: ${wMBold};
  color: ${primaryHeadingColor};
  letter-spacing: -0.5px;
  font-size: 18px;
  line-height: 21px;
  min-height: 42px;
`;

const ImageHero = styled.img`
  border-right: 1px solid #fff;
  height: 100%;
  width: 100%;
`;

const ImageTileOne = styled.img`
  border-bottom: 1px solid #fff;
  height: 50%;
  width: 100%;
`;

const DigestTile = function DigestTile(props: DigestProps) {
  const {
    widgetId, title, personWidget, imagesURL, createDigest, themeId,
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const elementRef = useRef<HTMLDivElement>(null);
  const digestResponseData = useSelector(selectCreateDigestData);
  const compaignId = digestResponseData?.campaignId;
  const emailId = digestResponseData?.emailId;
  const redirectWorkbench = useSelector(selectRedirectWorkbench);
  const createDiestLoading = useSelector(selectPersonDigestLoading);
  const WORKBENCH_ROUTE = process.env.REACT_APP_WORKBENCH_URL || '';
  const showDigestPopup: boolean = useSelector(selectShowDigestPopup);
  const { href } = window.location;

  const handleTileClicked = () => {
    if (personWidget && !createDiestLoading) {
      dispatch(personProfileActions.setShowDigestPopup(!showDigestPopup));
      createDigest(themeId);
    } else {
      navigate(`/news?widget=${widgetId}`);
    }
  };
  useEffect(() => {
    if (redirectWorkbench && compaignId && emailId) {
      // window.open(`${WORKBENCH_ROUTE}campaigns/editionedit/design/?campaign_id=${compaignId}&email_id=${emailId}&salesx=true`, '_blank');
      window.location.href = `${WORKBENCH_ROUTE}campaigns/editionedit/design/?campaign_id=${compaignId}&email_id=${emailId}&salesx=true&redirectToSalesapp=${href}`;
    }
  }, [redirectWorkbench, compaignId, emailId]);

  return (
    <Wrapper className={classNames('c-pointer', { personDigestTile: personWidget })}>
      <div onClick={() => handleTileClicked()} onKeyPress={() => handleTileClicked()} role="button" tabIndex={0}>
        {imagesURL && (
          <ImageWrapper className="image-wrapper-styled d-flex flex-row">
            <div className="heroImageWrap" ref={elementRef}>
              {imagesURL.slice(0, 1).map((item) => (
                <ImageHero key={item} src={item} alt="heroArticle" />
              ))}
            </div>

            <div className="digestTileImage">
              {imagesURL.slice(1, 3).map((item) => (
                <ImageTileOne key={item} src={item} alt="tileOneImage" />
              ))}
            </div>
          </ImageWrapper>
        )}
        <TextWrapper className="digest-text-wrapper">
          <Paragraph className="digest-tile-paragraph text-truncate-two-line">{title}</Paragraph>
        </TextWrapper>
      </div>
    </Wrapper>

  );
};

DigestTile.defaultProps = defaultProps;
export default DigestTile;